module.exports = __webpack_public_path__ + "img/62.1403cf8f.svg";